import { Model } from '@/models/Model';
import { Brand } from './Brand';

export class PurchaseOrderSummary extends Model{
  protected $name: string = 'PurchaseOrderSummary';

  protected $endpoint: string = '/purchase-orders';

  protected $fillable: string[] = [];

  public $purchaseOrderId: string = '';

  public id?: string;

  public brand?: string | Brand;

  public buy_price?: string;

  public size?: Record<string, number>;

  public supplier_color?: string;

  public all(): Promise<any> {
    const url = `${this.$endpoint}/${this.$purchaseOrderId}/summary`;

    return this.request("get", url);
  }
}
